<div class="row">
  <div class="col-md-12 btn-group positionnavigation">
    @if (('task.offer.change'|HasPerm)) {
      <button class="btn btn-default btn-sm" (click)="addArticlePosition()">
        Artikel hinzufügen
      </button>
    }

    @if (('task.offer.change'|HasPerm)) {
      <button class="btn btn-default btn-sm" (click)="addExtraCostPosition()">
        Zusatzkosten hinzufügen
      </button>
    }

    @if (('task.offer.change'|HasPerm)) {
      <button class="btn btn-default btn-sm" (click)="changeAllCalculations()">
        Kalkulation wechseln
      </button>
    }

    @if (('task.offer.change'|HasPerm)) {
      <button class="btn btn-default btn-sm" (click)="changeAllProducers()">
        Produzent festlegen
      </button>
    }
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    @if (('task.offer.change'|HasPerm)) {
      <position-box-list [data]="data"
        [listChange]="listChange"
        (updatePosition)="doPositionUpdate($event)"
        >
      </position-box-list>
    }
    @if (!('task.offer.change'|HasPerm)) {
      <position-readonly-box [positions]="data.workflow.positions">
      </position-readonly-box>
    }
  </div>
</div>

